import React from 'react';

import AppUgc from 'ugc/components/AppUgc';
import GeneralClientFlowWrapper from 'client/components/GeneralClientFlowWrapper';

export default function RouteUgc({ match, location }) {
    return (
        <GeneralClientFlowWrapper>
            <AppUgc match={match} location={location} />
        </GeneralClientFlowWrapper>
    );
}
